"use strict";

exports.__esModule = true;
exports.ManualMaintenanceActionDialog = exports.COMPONENT_USAGE_PLAN_TYPE = void 0;
var _core = require("@blueprintjs/core");
var _finalFormArrays = _interopRequireDefault(require("final-form-arrays"));
var _react = _interopRequireWildcard(require("react"));
var _reactFinalForm = require("react-final-form");
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _UI = require("../../../Utils/UI");
var _API = require("../../API");
var _constants = require("../../Auth/constants");
var _Selector = require("../../Core/Selector");
var _Translator = require("../../Core/Translator");
var _MultiDeviceSelector = require("../../Device/MultiDeviceSelector");
var _Env = require("../../Env");
var _FormGroupField = require("../../Form/FormGroupField");
var _Profile = require("../../Profile");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var COMPONENT_USAGE_PLAN_TYPE = exports.COMPONENT_USAGE_PLAN_TYPE = "Component Usage";
var ManualMaintenanceDialog = (0, _styledComponents["default"])(_core.Dialog).withConfig({
  displayName: "ManualMaintenanceActionDialog__ManualMaintenanceDialog",
  componentId: "sc-1dyftrk-0"
})([".", "{border-top:1px solid rgba(0,0,0,0.1);padding-top:1rem;}"], _core.Classes.DIALOG_FOOTER);
var FormBodySection = _styledComponents["default"].div.withConfig({
  displayName: "ManualMaintenanceActionDialog__FormBodySection",
  componentId: "sc-1dyftrk-1"
})(["margin:1rem 1rem 0 1rem;"]);
var isComponentUsagePlan = function isComponentUsagePlan(plan) {
  return (plan == null ? void 0 : plan.planType) === COMPONENT_USAGE_PLAN_TYPE;
};
var isOnlyComponentUsageSelection = function isOnlyComponentUsageSelection(selectedPlans) {
  return Array.isArray(selectedPlans) && selectedPlans.length > 0 && selectedPlans.every(isComponentUsagePlan);
};
var toDeviceUuids = function toDeviceUuids(selectedDevices) {
  return (selectedDevices || []).map(function (device) {
    return typeof device === "string" ? device : device.uuid;
  });
};

/**
 * Dialog for creating manual maintenance activities.
 *
 * Pass `deviceId` to fetch plans for that device and let the operator pick plans.
 * Pass `plan` with `devices` to fix the plan and let the operator pick devices.
 */
var ManualMaintenanceActionDialog = exports.ManualMaintenanceActionDialog = function ManualMaintenanceActionDialog(props) {
  var deviceId = props.deviceId,
    plan = props.plan,
    devices = props.devices,
    initialDevices = props.initialDevices,
    label = props.label,
    isOpen = props.isOpen,
    toggleDialog = props.toggleDialog;
  var usePlanPicker = Boolean(deviceId) && !plan;
  var useDevicePicker = Boolean(plan);
  var _useState = (0, _react.useState)(false),
    pending = _useState[0],
    setPending = _useState[1];
  var _useState2 = (0, _react.useState)([]),
    plans = _useState2[0],
    setPlans = _useState2[1];
  var _React$useContext = _react["default"].useContext(_Profile.ProfileContext),
    user = _React$useContext.user;
  var _React$useContext2 = _react["default"].useContext(_Env.EnvContext),
    licence = _React$useContext2.licence;
  var hasMaintenanceManagerAccess = licence.accessRights.includes(_constants.ACCESS_RIGHT_MAINTENANCE_MANAGER);
  var validatePlans = function validatePlans(value) {
    if (!Array.isArray(value) || value.length === 0) {
      return /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "ManualMaintenance.deviceError",
        defaultMessage: "Plan is required."
      });
    }
  };
  var validateDevices = function validateDevices(value) {
    if (!Array.isArray(value) || value.length === 0) {
      return /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "NewLogbookComment.deviceError",
        defaultMessage: "Device is required."
      });
    }
  };
  (0, _react.useEffect)(function () {
    if (usePlanPicker) {
      fetchDevicePlans();
    }
  }, [deviceId, usePlanPicker]);
  var api = _react["default"].useContext(_API.RestAPIContext);
  var _React$useContext3 = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext3.translate;
  var fetchDevicePlans = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var result, devicePlans;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return api.get("/api/v1/maintain/plan");
          case 1:
            result = _context.v;
            devicePlans = result.filter(function (plan) {
              return plan.assetIDs.includes(deviceId) && plan.isEnabled == true;
            });
            setPlans(devicePlans);
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function fetchDevicePlans() {
      return _ref.apply(this, arguments);
    };
  }();
  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(values) {
      var selectedPlan, selectedDevices, comment, initialValue, plansToSubmit, assetIDs, i, planToSubmit, j, output, _t;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            selectedPlan = values.selectedPlan, selectedDevices = values.selectedDevices, comment = values.comment, initialValue = values.initialValue;
            plansToSubmit = plan ? [plan] : selectedPlan;
            assetIDs = plan ? selectedDevices : [deviceId];
            _context2.p = 1;
            i = 0;
          case 2:
            if (!(i < plansToSubmit.length)) {
              _context2.n = 8;
              break;
            }
            planToSubmit = plansToSubmit[i];
            j = 0;
          case 3:
            if (!(j < assetIDs.length)) {
              _context2.n = 7;
              break;
            }
            output = {
              planID: planToSubmit.id,
              assetID: assetIDs[j],
              currentValues: [{
                conditionType: comment || "string",
                currentValue: 100
              }],
              evaluatedTs: new Date().toISOString(),
              taskStatus: pending ? "IN_PROGRESS" : "CLOSED",
              comment: comment ? {
                body: comment,
                author: {
                  type: "USER",
                  value: user.username
                }
              } : undefined
            };
            if (hasMaintenanceManagerAccess && !pending && initialValue && isComponentUsagePlan(planToSubmit)) {
              output.initialValue = Number(initialValue);
            }
            if (!pending) {
              _context2.n = 5;
              break;
            }
            _context2.n = 4;
            return api.put("/api/v1/maintain/pending", output);
          case 4:
            _context2.n = 6;
            break;
          case 5:
            _context2.n = 6;
            return api.put("/api/v1/maintain/completed", output);
          case 6:
            j++;
            _context2.n = 3;
            break;
          case 7:
            i++;
            _context2.n = 2;
            break;
          case 8:
            (0, _UI.showSuccessToaster)(translate("ManualMaintenance.save.success", "Manual Maintenance has been successfully created"));
            toggleDialog();
            _context2.n = 10;
            break;
          case 9:
            _context2.p = 9;
            _t = _context2.v;
            (0, _UI.showErrorToaster)(translate("ManualMaintenance.save.error", "Manual Maintenance could not be changed"));
            console.error(_t);
          case 10:
            return _context2.a(2);
        }
      }, _callee2, null, [[1, 9]]);
    }));
    return function handleSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var formInitialValues = {
    selectedDevices: useDevicePicker ? toDeviceUuids(initialDevices != null ? initialDevices : []) : undefined
  };
  return /*#__PURE__*/_react["default"].createElement(ManualMaintenanceDialog, {
    isOpen: isOpen,
    onClose: toggleDialog,
    title: label
  }, /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Form, {
    initialValues: formInitialValues,
    keepDirtyOnReinitialize: true,
    onSubmit: handleSubmit,
    mutators: Object.assign({}, _finalFormArrays["default"])
  }, function (_ref3) {
    var handleSubmit = _ref3.handleSubmit,
      submitting = _ref3.submitting,
      values = _ref3.values;
    var showInitialValueField = hasMaintenanceManagerAccess && !pending && (useDevicePicker ? isComponentUsagePlan(plan) : isOnlyComponentUsageSelection(values.selectedPlan));
    return /*#__PURE__*/_react["default"].createElement("form", {
      style: {
        width: "100%"
      },
      onSubmit: handleSubmit
    }, /*#__PURE__*/_react["default"].createElement(FormBodySection, null, usePlanPicker && /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
      name: "selectedPlan",
      label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "ManualMaintenance.planSelector",
        defaultMessage: "Plans"
      }),
      validate: validatePlans,
      helperText: plans.length === 0 ? translate("ManualMaintenance.noPlans", "No maintenance plans are available for this device.") : undefined
    }, function (_ref4) {
      var input = _ref4.input;
      return /*#__PURE__*/_react["default"].createElement("div", {
        "data-testid": "ManualMaintenancePlansSelector"
      }, /*#__PURE__*/_react["default"].createElement(_Selector.Selector, _extends({
        placeholder: ("MaintenanceManager.Activities.PlanNames", "Plans"),
        itemPredicate: function itemPredicate(query, item) {
          return item.name.toLowerCase().includes(query);
        }
      }, input, {
        multiple: true,
        style: {
          marginLeft: "15px",
          maxWidth: "250px"
        },
        items: plans,
        renderItemText: function renderItemText(item) {
          return item.name;
        },
        getKey: function getKey(item) {
          return item.id;
        },
        selected: Array.from(input.value || []),
        onSelect: input.onChange,
        usePortal: false
      })));
    }), useDevicePicker && /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
      name: "selectedDevices",
      label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "ManualMaintenance.deviceSelector",
        defaultMessage: "Devices"
      }),
      validate: validateDevices
    }, function (_ref5) {
      var input = _ref5.input;
      return /*#__PURE__*/_react["default"].createElement("div", {
        "data-testid": "ManualMaintenanceDevicesSelector"
      }, /*#__PURE__*/_react["default"].createElement(_MultiDeviceSelector.MultiDeviceSelector, {
        devices: devices || [],
        tags: [],
        selected: input.value || [],
        onSelect: function onSelect(selected) {
          return input.onChange(toDeviceUuids(selected));
        }
      }));
    }), /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
      name: "comment",
      label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "ManualMaintenance.comment",
        defaultMessage: "Comments"
      })
    }, function (_ref6) {
      var input = _ref6.input;
      return /*#__PURE__*/_react["default"].createElement(_core.TextArea, _extends({
        "data-testid": "CommentTextArea",
        fill: true,
        style: {
          height: "100px"
        }
      }, input));
    }), showInitialValueField && /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
      name: "initialValue",
      label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "MaintenanceManager.initialValue",
        defaultMessage: "Initial Value"
      })
    }, function (_ref7) {
      var input = _ref7.input;
      return /*#__PURE__*/_react["default"].createElement(_core.InputGroup, _extends({
        "data-testid": "InitialValueInput",
        type: "number",
        min: 0,
        fill: true,
        rightElement: /*#__PURE__*/_react["default"].createElement(_core.Tag, {
          style: {
            margin: "0 5px 0 5px"
          },
          minimal: true
        }, translate("MaintenanceManager.Condition.Units.hours", "hours"))
      }, input));
    }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_core.RadioGroup, {
      label: "",
      onChange: function onChange(e) {
        return setPending(e.target.value === "true");
      },
      selectedValue: pending.toString()
    }, /*#__PURE__*/_react["default"].createElement(_core.Radio, {
      label: translate("ManualMaintenance.activity.completed", "Maintenance has been completed"),
      value: "false"
    }), /*#__PURE__*/_react["default"].createElement(_core.Radio, {
      label: translate("ManualMaintenance.activity.pending", "Maintenance is pending"),
      value: "true"
    }))), /*#__PURE__*/_react["default"].createElement(FormBodySection, null)), /*#__PURE__*/_react["default"].createElement("div", {
      className: _core.Classes.DIALOG_FOOTER
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _core.Classes.DIALOG_FOOTER_ACTIONS
    }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      "data-testid": "ManualMaintenanceFormSubmit",
      type: "submit",
      intent: _core.Intent.PRIMARY,
      loading: submitting,
      disabled: usePlanPicker && plans.length === 0,
      text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "ManualMaintenance.create.button.comment",
        defaultMessage: "Submit"
      })
    }))));
  }));
};